module.exports = __webpack_public_path__ + "img/zhiwen.cf37fdf6.png";